import { useFetchUserDeviceInfo, User } from '@/models/user';
import { Alert, Descriptions, Empty } from 'antd';
import { useEffect } from 'react';
import IPGeolocation from '../IPGeolocation';
import Loading from '../Loading';
import AsyncWrapper from '../AsyncWrapper';
import Exception from '../Exception';

export const UserDeviceInfo = ({ user }: { user: User }) => {
  const { send, payload: deviceInfo, loading, error, loaded } = useFetchUserDeviceInfo();

  const fetchDeviceInfo = async () => {
    send({ pathVars: { username: user.username } });
  };

  useEffect(() => {
    if (user && user.username) {
      fetchDeviceInfo();
    }
  }, [user?.username]);

  return (
    <AsyncWrapper loading={loading} error={error} render={loaded}>
      {() => {
        if (!deviceInfo) {
          return <Alert message="无设备信息" type="info" showIcon />;
        }
        return (
          <Descriptions title="设备信息" size="small" bordered layout="horizontal" column={1}>
            <Descriptions.Item label="IP">
              <div>{user.lastLoginIp || '--'}</div>
              <div>
                <IPGeolocation ip={user.lastLoginIp} />
              </div>
            </Descriptions.Item>
            <Descriptions.Item label="Brand">{deviceInfo.brand || '--'}</Descriptions.Item>
            <Descriptions.Item label="Model">{deviceInfo.model || '--'}</Descriptions.Item>
            <Descriptions.Item label="System">{deviceInfo.system || '--'}</Descriptions.Item>
            <Descriptions.Item label="benchmark">{deviceInfo.benchmarkLevel || '--'}</Descriptions.Item>
            <Descriptions.Item label="Weapp SDK Version">{deviceInfo.wxSdkVersion || '--'}</Descriptions.Item>
          </Descriptions>
        );
      }}
    </AsyncWrapper>
  );
};
